import {GroupsState} from '../groups/redux/reducer';
import {useAppSelector} from './redux';

export const useGroups = (): GroupsState => {
  return useAppSelector(state => state.entities.groups);
};
